import { doc, collection, runTransaction } from "firebase/firestore";
import { db } from "../firebase/config";

const LOGO_URL = "https://firebasestorage.googleapis.com/v0/b/bodyown-staging.firebasestorage.app/o/logo%2Fbodyown-logo.png?alt=media&token=b3cba539-4cd5-4a19-97a2-f87a908c0bbd";

export async function maybeSendWelcomeEmail(uid: string) {
  try {
    await runTransaction(db, async (transaction) => {
      const userDocRef = doc(db, "users", uid);
      const userSnap = await transaction.get(userDocRef);

      if (!userSnap.exists()) return;

      const userData = userSnap.data();
      if (userData.welcomeEmailSent) return;
      if (!userData.email) return;

      const firstName = userData.firstName ?? "";
      const mailDocRef = doc(collection(db, "mail"));

      transaction.set(mailDocRef, {
        to: userData.email,
        message: {
          subject: "Welcome to BodyOwn 🤍",
          html: `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <style>
    body { margin: 0; padding: 0; background-color: #f8f5f2; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; -webkit-font-smoothing: antialiased; }
    .wrapper { max-width: 580px; margin: 40px auto; background: #ffffff; border-radius: 16px; box-shadow: 0 4px 12px rgba(29, 21, 14, 0.04); overflow: hidden; border: 1px solid #eeeade; }
    .header { padding: 48px 40px 24px 40px; text-align: center; }
    .header img { height: 42px; width: auto; display: inline-block; border: 0; filter: none; }
    .divider { height: 1px; background-color: #eeeade; margin: 0 40px; }
    .body { padding: 40px; color: #3a3530; font-size: 16px; line-height: 1.75; letter-spacing: -0.01em; }
    .greeting { font-size: 18px; font-weight: 600; color: #1e5e5b; margin-bottom: 20px; }
    .body ul { padding-left: 20px; margin: 16px 0; }
    .body ul li { margin-bottom: 10px; color: #4e4842; }
    .body a { color: #1e5e5b; font-weight: 600; text-decoration: underline; text-underline-offset: 4px; }
    .body a:hover { color: #143f3d; }
    .footer { padding: 32px 40px; background-color: #fdfbfa; color: #8a827a; font-size: 12px; text-align: center; border-top: 1px solid #f4f0ea; letter-spacing: 0.02em; }
  </style>
</head>
<body>
  <div class="wrapper">
    <div class="header">
      <img src="${LOGO_URL}" alt="BodyOwn Logo" height="42" style="height: 42px; width: auto; display: inline-block; border: 0; filter: none;" />
    </div>
    <div class="divider"></div>
    <div class="body">
      <p class="greeting">Hi ${firstName},</p>
      <p>Welcome and thank you for signing up to test BodyOwn.</p>
      <p>BodyOwn was created to help women feel more informed, reassured, and supported during recovery after birth.</p>
      <p>As you explore the app over the coming days, we'd be particularly interested in hearing:</p>
      <ul>
        <li>How easy it is to navigate;</li>
        <li>Whether the information feels clear and relevant;</li>
        <li>Anything you expected to find but couldn't see;</li>
        <li>Any technical issues you encounter.</li>
      </ul>
      <p>If you experience a technical issue while using the app, you can report it directly through the <strong>Give Feedback</strong> section within your Profile area. You can also use the <strong>Propose an Enhancement</strong> section to share ideas for improvements as you explore.</p>
      <p>There is no right or wrong way to use the app — simply explore it as you normally would.</p>
      <p>If you have any questions or need help while testing, you can <a href="https://bit.ly/bodyown-whatsapp-email">contact us on WhatsApp</a>.</p>
      <p>After you've had a chance to explore the platform, we'll invite you to share your feedback and tell us about your experience.</p>
      <p style="margin-top: 32px;">Thank you again for helping us shape BodyOwn.</p>
      <p style="line-height: 1.5; margin-top: 24px;">Warm wishes,<br /><strong style="color: #1e5e5b;">The BodyOwn Team</strong></p>
    </div>
    <div class="footer">
      &copy; ${new Date().getFullYear()} BodyOwn. All rights reserved.
    </div>
  </div>
</body>
</html>`,
        },
      });

      transaction.update(userDocRef, { welcomeEmailSent: true });
    });
    console.log("Welcome email evaluation complete.");
  } catch (err) {
    console.error("WELCOME EMAIL TRANSACTION FAILED:", err);
  }
}